module.exports = __webpack_public_path__ + "static/media/ends_with_i.d7d0e3f5.mp3";